import { Injectable } from '@angular/core'

import { Action, Resource, TSP_ADMIN_PERMISSIONS, TSP_RESOURCES } from '@ti/contracts'
import { BaseRoleEditModel, PermissionDependency } from '@ti/shared/roles/models'

@Injectable()
export class TspRoleEditModel extends BaseRoleEditModel {
  public readonly allowedActions = [
    Action.View,
    Action.Create,
    Action.Update,
    Action.Delete,
    Action.Suspend,
    Action.LoginAs,
  ]
  public readonly allowedResources = TSP_RESOURCES
  public readonly defaultPermissions = TSP_ADMIN_PERMISSIONS
  public readonly lockedActions: Partial<Record<Resource, Action[]>> = {}
  public readonly permissionDependencies: PermissionDependency[] = [
    {
      resource: Resource.Billing,
      actions: [Action.View],
      requires: [[Resource.SMS, Action.View]],
    },
    // Audit log and developer API are always granted and revoked together, hence the opposing pair
    {
      resource: Resource.AuditLog,
      actions: [Action.View],
      requires: [[Resource.DeveloperApi, Action.View]],
    },
    {
      resource: Resource.DeveloperApi,
      actions: [Action.View],
      requires: [[Resource.AuditLog, Action.View]],
    },
    {
      resource: Resource.Role,
      actions: [Action.View],
      requires: [[Resource.User, Action.View]],
    },
  ]
}
